import { TimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';

type CustomTimePickerProps = Omit<TimePickerProps<Dayjs>, 'value' | 'onChange' | 'renderInput'> & {
    label: string;
    value: string | null;
    onChange: (isoString: string) => void;
    required?: boolean;
    disabled?: boolean;
    small?: boolean;
    readOnly?: boolean;
};

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({
    label,
    value,
    onChange,
    required = false,
    disabled = false,
    small = true,
    readOnly = true,
    ...rest
}) => {
    return (
        <div style={{ padding: 5 }}>
            <TimePicker
                ampm={false}
                value={value ? dayjs(value) : null}
                onChange={(newValue) => {
                    if (newValue) onChange(newValue.toISOString());
                }}
                label={`${label}${required ? ' *' : ''}`}
                disabled={disabled}
                slotProps={{
                    field: { readOnly },
                    textField: {
                        variant: 'outlined',
                        size: small ? 'small' : 'medium',
                        fullWidth: true,
                        disabled,
                        slotProps: {
                            inputLabel: {
                                shrink: true,
                            },
                        },
                        // will be deprecated
                        InputLabelProps: { shrink: true },
                    },
                }}
                {...rest}
            />
        </div>
    );
};

export default CustomTimePicker;
